export default "__VITE_ASSET__CxZm16lS__"